import React, { useEffect, useState } from "react"
import { Spinner } from "react-bootstrap";
import { indicadoresActions } from "../../redux/actions/Otros/indicadoresActions";
import { RootState } from "../../redux/reducers";
import { connect } from "react-redux";

export interface IndicadoresProps {
    valor: string | number;
}

interface Props {
    indicadoresActions: () => Promise<boolean>;
    habilitados: Record<
        "UTM" | "UF" | "Dólar" | "IPC" | "BTC" | "EURO" | "Ethereum",
        boolean
    >;
    utm: IndicadoresProps;
    uf: IndicadoresProps;
    dolar: IndicadoresProps;
    bitcoin: IndicadoresProps;
    ipc: IndicadoresProps;
    btc: IndicadoresProps;
    euro: IndicadoresProps;
    Ethereum: IndicadoresProps;
    isDarkMode: boolean;
}


const Indicador: React.FC<Props> = ({
    indicadoresActions,
    habilitados,
    utm,
    uf,
    dolar,
    ipc,
    btc,
    euro,
    Ethereum,
    isDarkMode
}) => {

    const [loading, setLoading] = useState(false);
    const indicadoresData = [
        {
            id: "UTM",
            title: "UTM",
            value: `$${Number(utm.valor).toLocaleString("es-CL")}`,
            habilitado: habilitados.UTM,
        },
        {
            id: "UF",
            title: "UF",
            value: `$${Number(uf.valor).toLocaleString("es-CL", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}`,
            habilitado: habilitados.UF,
        },
        {
            id: "Dólar",
            title: "Dólar",
            value: `$${Number(dolar.valor).toLocaleString("es-CL", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}`,
            habilitado: habilitados["Dólar"],
        },
        {
            id: "IPC",
            title: "IPC",
            value: `${Number(ipc.valor).toLocaleString("es-CL", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}%`,
            habilitado: habilitados.IPC,
        },
        {
            id: "BTC",
            title: "BTC",
            value: Number(btc.valor).toLocaleString("es-CL"),
            habilitado: habilitados.BTC,
        },
        {
            id: "EURO",
            title: "EURO",
            value: `$${Number(euro.valor).toLocaleString("es-CL", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}`,
            habilitado: habilitados.EURO,
        },
        {
            id: "Ethereum",
            title: "Ethereum",
            value: `$${Number(Ethereum.valor).toLocaleString("es-CL", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}`,
            habilitado: habilitados.Ethereum,
        },

    ];


    const cargaIndicadores = async () => {
        if (uf.valor === 0 && utm.valor === 0 && dolar.valor === 0 && ipc.valor === 0) {
            setLoading(true);
            const resultado = await indicadoresActions();
            if (resultado) {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        cargaIndicadores();
    }, [indicadoresActions]);

    const noDisponible = (valor: string | number): boolean => {
        if (valor === null || valor === undefined || String(valor).trim() === "") {
            return true;
        }

        const texto = String(valor).trim();

        const numero = Number(
            texto.includes(",")
                ? texto.replace(/\./g, "").replace(",", ".")
                : texto
        );

        return !Number.isFinite(numero) || numero === 0;
    };

    return (
        <>
            {indicadoresData
                .filter(
                    (item) => item.habilitado && !noDisponible(
                        item.id === "UTM" ? utm.valor :
                            item.id === "UF" ? uf.valor :
                                item.id === "Dólar" ? dolar.valor :
                                    item.id === "IPC" ? ipc.valor :
                                        item.id === "BTC" ? btc.valor :
                                            item.id === "EURO" ? euro.valor :
                                                Ethereum.valor
                    )
                )
                .map((item) => (
                    <div className={`text-center fs-6 p-1 mx-1 border-0 rounded h-100 d-flex align-items-center justify-content-center ${isDarkMode ? "text-light border-secondary" : "text-muted"}`} key={item.id}   >
                        <div className="mx-1">
                            <strong className="no-cursor">{item.title}</strong>
                        </div>
                        {loading ? (
                            <Spinner className="fs-6" size="sm" />
                        ) : (
                            <div className="fw-semibold no-cursor">{item.value}</div>
                        )}
                    </div>

                ))}

        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    isDarkMode: state.darkModeReducer.isDarkMode,
    utm: state.indicadoresReducers.utm || 0,
    uf: state.indicadoresReducers.uf || 0,
    dolar: state.indicadoresReducers.dolar || 0,
    bitcoin: state.indicadoresReducers.bitcoin || 0,
    ipc: state.indicadoresReducers.ipc || 0,
    btc: state.indicadoresReducers.btc || 0,
    euro: state.indicadoresReducers.euro || 0,
    Ethereum: state.indicadoresReducers.Ethereum || 0,
    habilitados: state.actualizarIndicadorHabilitadoReducers.habilitados || [],
});

export default connect(mapStateToProps, {
    indicadoresActions
})(Indicador);